import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useLoginRedirect } from "@/composables/useLoginRedirect";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPageCorp',
  setup(__props) {

useLoginRedirect("corp");

return (_ctx: any,_cache: any) => {
  const _component_q2_loading = _resolveComponent("q2-loading")!

  return (_openBlock(), _createBlock(_component_q2_loading, { modifiers: "" }))
}
}

})